<template>
  <el-dialog title="Instalar Placa no Imóvel" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      <el-form-item label="Placas" style="width: 100%">
        <el-select v-model="placaSelecionada"
          :remote-method="recuperarPlacasSelect"
          :loading="loadingPlacas"
          value-key="id"
          placeholder=""
          loading-text="Carregando placas"
          no-data-text="Nenhuma placa encontrada"
          filterable
          remote
          reserve-keyword
          style="width: 100%">
          <el-option
            v-for="item in placasDisponiveis"
            :key="item.id"
            :label="item.tipo"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Data de Instalação">
        <el-date-picker
          v-model="dataColocacao"
          v-mask="'##/##/####'"
          type="date"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="Responsável pela Instalação" style="width: 100%">
        <el-select v-model="usuarioColocacao"
          :remote-method="recuperarUsuariosSelect"
          :loading="loadingUsuarios"
          value-key="id"
          placeholder="Pesquise o Colaborador"
          filterable
          remote
          reserve-keyword
          style="width: 100%">
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="colocarPlaca()" size="small" type="primary" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Util from '../../../util/funcoes.js'

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      loadingPlacas: false,
      loadingUsuarios: false,
      placaSelecionada: { id: 0 },
      usuarioColocacao: { id: 0 },
      dataColocacao: Util.hoje(),
      placasDisponiveis: [],
      usuariosDisponiveis: []
    }
  },
  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    ...mapState('alugueisImoveisStore', {
      imovel(state) { return state.imovelSelecionado }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisImoveisStore', [
      'recuperarPlacas',
      'gravarPlacaNoImovel',
      'listarUsuarios'
    ]),
    recuperarUsuariosSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      
      this.listarUsuarios(payload)
        .then((resultado) => {
          this.loadingUsuarios = false;
          if (resultado.status === "SUCESSO") {
            this.usuariosDisponiveis = resultado.lista;
          }
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    recuperarPlacasSelect(queryString) {
      let payload = { tipo: queryString }
      
      this.loadingPlacas = true;
      this.recuperarPlacas(payload)
      .then((resultado) => {
        this.loadingPlacas = false;
        switch(resultado.status) {
          case "SUCESSO":
            this.placasDisponiveis = resultado.lista;
            break;
        }
      });
    },
    colocarPlaca() {
      if(!this.placaSelecionada || this.placaSelecionada.id == 0) {
        this.$message.warning("Selecione o tipo de placa");
        return;
      }

      if(!this.usuarioColocacao || !this.usuarioColocacao.id) {
        this.$message.warning("Selecione o responsável pela instalação");
        return;
      }

      let idImovel = this.imovel && this.imovel.id ? this.imovel.id : (this.$route && this.$route.params ? this.$route.params.id : 0);
      if (idImovel === 0) {
        this.$message.error("Tente atualizar a página.");
        return;
      }

      let payload = {
        id: this.placaSelecionada.id,
        tipo: this.placaSelecionada.tipo,
        imovel: { id: idImovel },
        dataColocacao: this.dataColocacao,
        usuarioColocacao: { 
          id: this.usuarioColocacao.id,
          nome: this.usuarioColocacao.nome   
        }
      };

      this.showLoading();
      this.gravarPlacaNoImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Erro ao comunicar com o servidor.");
      });
    },
    fechar() {
      this.$emit('close');
    }
  },
  watch: {
    visibility(val) {
      if (val) {
        const logado = Object.assign({}, this.usuarioLogado);
        this.usuariosDisponiveis = [logado];
        this.usuarioColocacao = logado;
        this.placaSelecionada = { id: 0 };
      }
    }
  }
}
</script>

